module.exports = __webpack_public_path__ + "static/img/jiugongge_.d40819ad.jpg";